import moment from "moment";
import { useEffect, useState } from "react";
import Select from "react-select";
import swal from "sweetalert2";
import * as helper from '../global/helper';
import { addUserRangeSubscription } from "../api/matAPI";

const AddRangeSubscriptionModal = (props) => {

    const { userTypeOptions, onUserTypeChange, userListOptions, subscriptionMasters, onSubscriptionMasterChange, subscriptionDetails, onSuccess, selectedRow } = props;

    const [selectedUserType, setSelectedUserType] = useState(null);
    const [selectedUser,     setSelectedUser]     = useState(null);
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState(null);
    const [subscriptionPaymentDetails, setSubscriptionPaymentDetails] = useState({
        MembershipFee: 0,
        SubscriptionCharge: 0,
        GST: 0,
        GSTAmount: 0,
        Total: 0
    });

    useEffect(() => {
        if (props.show) {
            $('#add-range-subscription-modal').modal({
                backdrop: 'static',
            });
            $('#add-range-subscription-modal').modal('show');

            $('#add-range-subscription-modal').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal && props.onDismissModal(false);
        });
        }
        if (Object.keys(subscriptionDetails).length > 0) {
            setSubscriptionPaymentDetails(d => ({ ...d, ...subscriptionDetails }));
        }
    }, [props.show, subscriptionDetails]);

    useEffect(() => {
        if (!selectedRow) return;

        setSubscriptionPaymentDetails(d => ({ ...d, Comment: selectedRow?.Comment || '' }));
    }, [selectedRow]);

    // selected correct subscription plan in case of UPDATE scenario
    useEffect(() => {
        if (!selectedRow) return; // for add do nothing
        if(!subscriptionMasters?.length) return;

        const sub = subscriptionMasters?.find(s => s.value === selectedRow.SubscriptionID);

        setSelectedSubscriptionPlan(sub || null);

        setSubscriptionPaymentDetails(d => ({ ...d, SubscriptionID: selectedRow?.SubscriptionID }));
    }, [selectedRow, subscriptionMasters]);

    // selected correct user type in case of UPDATE scenario
    useEffect(() => {
        if (!selectedRow) return; // for add do nothing
        if (!userTypeOptions?.length) return;

        const type = userTypeOptions.find(t => t.value === selectedRow.SubCategoryID);

        setSelectedUserType(type || null);

        type && onUserTypeChange?.(type);
    }, [selectedRow, userTypeOptions]);

    // selected correct user in case of UPDATE scenario
    useEffect(() => {
        if (!selectedRow) return; // for add do nothing
        if (!userListOptions?.length) return;

        const user = userListOptions.find(
            u => u.value === selectedRow.UserID
        );
        
        setSelectedUser(user || null);
    }, [selectedRow, userListOptions]);


    useEffect(() => {
            const Charge = parseFloat(subscriptionPaymentDetails?.SubscriptionCharge);
            const GST    = parseFloat(subscriptionPaymentDetails?.GST);
            const MembershipFee = parseFloat(subscriptionPaymentDetails?.MembershipFee);
            const combinedAmount = MembershipFee + Charge; // excluding GST
            const GSTAmount = Math.round((combinedAmount * GST) / 100);
            const Total = GSTAmount + Math.round(combinedAmount);

            setSubscriptionPaymentDetails(d => ({ ...d, GSTAmount, Total }));
    }, [subscriptionPaymentDetails?.MembershipFee, Math.round(parseFloat(subscriptionPaymentDetails?.SubscriptionCharge)), Math.round(subscriptionPaymentDetails?.GST)]);

    const closeModal = () => {
        $('#add-range-subscription-modal').modal('hide');
        setSelectedUserType(null);
        setSelectedUser(null);
        setSelectedSubscriptionPlan(null)
        setSubscriptionPaymentDetails({
            MembershipFee: 0,
            SubscriptionCharge: 0,
            GST: 0,
            GSTAmount: 0,
            Total: 0,
            Comment: ''
        });
    };

    const updateSubscriptionPaymentDetails = (field, value) => {
        setSubscriptionPaymentDetails((d) => {
            return { ...d, [field]: value };
        });
    };

    const addChargeHandler = async (e) => {
        e.preventDefault();

        const btn = $('#btnSave');
        var form = $('#add-sub-form');

        form.validate({
            rules: {
                ddlUserType: {
                    required: true
                },
                ddlUser: {
                    required: true
                },
                ddlSubscriptionPlan: {
                    required: true
                },
                txtSubscriptionStartsFrom: {
                    required: true,
                },         
                txtSubscriptionExpiresOn: {
                    required: true,
                },         
                txtCharge: {
                    required: true
                },          
                txtGST: {
                    required: true
                },
                txtMembershipFee: {
                    required: true
                }
            },
            messages: {
                ddlUserType: {
                    required: "Please select user type"
                },
                ddlUser: {
                    required: "Please select a user"
                },
                ddlSubscriptionPlan: {
                    required: "Please select subscription plan"
                },
                txtSubscriptionStartsFrom: {
                    required: "Please select subscription starts from"
                },
                txtSubscriptionExpiresOn: {
                    required: "Please select subscription expires On"
                },
                txtCharge: {
                    required: "Please enter charge"
                },
                txtGST: {
                    required: "Please enter gst"
                },
                txtMembershipFee: {
                    required: "Please enter Membership Fee"
                }
            }
        });

        if (!form.valid()) return;
        if (moment(subscriptionPaymentDetails?.SubscriptionStartsFrom).isAfter(subscriptionPaymentDetails?.SubscriptionExpiresOn)) {
            swal.fire({
                icon                  : 'warning',
                titleText             : 'Date Conflict!',
                buttonsStyling        : false,  
                confirmButtonClass    : 'btn btn-brand'
            });
            helper.StopProcessing(btn);
            return;
        }
        helper.StartProcessing(btn);

        try {
            const payload = {
                ID: selectedRow?.ID || 0,
                UserID: selectedUser.value,
                UserType: selectedUser?.subCategoryID === 1 ? 'User' : 'Guest',
                SubCategoryID: selectedUser?.subCategoryID,
                SubscriptionID: subscriptionPaymentDetails?.SubscriptionID,
                StartDate: subscriptionPaymentDetails?.SubscriptionStartsFrom,
                EndDate: subscriptionPaymentDetails?.SubscriptionExpiresOn,
                Total: subscriptionPaymentDetails?.Total,
                GSTPercentage: subscriptionPaymentDetails?.GST,
                GSTAmount: subscriptionPaymentDetails?.GSTAmount,
                MembershipFee: subscriptionPaymentDetails?.MembershipFee,
                Comment: subscriptionPaymentDetails?.Comment
            };
            await addUserRangeSubscription(payload);
            helper.StopProcessing(btn);
            if (selectedRow?.ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Subscription updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,
                    animation: false,
                    customClass: {
                        popup: 'margin-20'
                    }
                });
            } else {
                swal.fire({
                    icon: 'success',
                    titleText: 'Subscription added successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            closeModal();
            onSuccess();
            return;
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand'
            });
            return;
        }
    };

    return (
        <>
            <div className="modal fade" id="add-range-subscription-modal" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Range Subscription</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={closeModal}
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="kt-form" id="add-sub-form">
                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                    <div className="row">
                                        <div className="col-4 form-group">
                                            <label>Type</label>
                                            <Select
                                                id="ddlUserType"
                                                name="ddlUserType"
                                                className="multi-custom"
                                                placeholder="Select User Type"
                                                options={userTypeOptions}
                                                value={selectedUserType}
                                                onChange={(option) => {
                                                    setSelectedUserType(option);
                                                    onUserTypeChange && onUserTypeChange(option);
                                                }}
                                                isDisabled={Boolean(selectedRow?.ID)}
                                            />
                                        </div>
                                        <div className="col-4 form-group">
                                            <label>Select User</label>
                                            <Select
                                                id="ddlUser"
                                                name="ddlUser"
                                                className="multi-custom"
                                                placeholder="Select User"
                                                options={userListOptions}
                                                value={selectedUser}
                                                onChange={(option) => setSelectedUser(option)}
                                                isDisabled={Boolean(selectedRow?.ID)}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-4 form-group">
                                            <label>Subscription Plan</label>
                                            <Select
                                                id="ddlSubscriptionPlan"
                                                name="ddlSubscriptionPlan"
                                                className="multi-custom"
                                                placeholder="Select Subscription Plan"
                                                options={subscriptionMasters}
                                                value={selectedSubscriptionPlan}
                                                onChange={(option) => {
                                                    setSelectedSubscriptionPlan(option);
                                                    onSubscriptionMasterChange(option);
                                                }} 
                                            />
                                        </div>
                                        <div className="col-4 form-group">
                                            <label>Subscription Starts From</label>
                                            <div className="input-group">
                                                <input
                                                    id="txtSubscriptionStartsFrom"
                                                    name="txtSubscriptionStartsFrom"
                                                    type="text"
                                                    placeholder="Select starts from"
                                                    className="form-control date-input"
                                                    value={subscriptionPaymentDetails?.SubscriptionStartsFrom ? moment(subscriptionPaymentDetails?.SubscriptionStartsFrom).format('DD-MM-YYYY'): ''}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i className="la la-calendar-check-o"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-4 form-group">
                                            <label>Subscription Expires On</label>
                                            <div className="input-group">
                                                <input
                                                    id="txtSubscriptionExpiresOn"
                                                    name="txtSubscriptionExpiresOn"
                                                    type="text"
                                                    placeholder="Select expires from"
                                                    className="form-control date-input"
                                                    value={subscriptionPaymentDetails?.SubscriptionExpiresOn ? moment(subscriptionPaymentDetails?.SubscriptionExpiresOn).format('DD-MM-YYYY'): ''}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i className="la la-calendar-check-o"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>Membership Fee</label>
                                            <input
                                                id="txtMembershipFee" 
                                                name="txtMembershipFee" 
                                                type="number" 
                                                className="form-control"
                                                value={subscriptionPaymentDetails?.MembershipFee !== undefined ? subscriptionPaymentDetails?.MembershipFee : ''}
                                                onChange={(event) => updateSubscriptionPaymentDetails('MembershipFee', event.target.value)} 
                                            />
                                        </div>
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>Subs. Charge</label>
                                            <input 
                                                id="txtCharge" 
                                                name="txtCharge" 
                                                type="number" 
                                                className="form-control"
                                                value={subscriptionPaymentDetails?.SubscriptionCharge !== undefined ? subscriptionPaymentDetails?.SubscriptionCharge : ''}
                                                onChange={(event) => updateSubscriptionPaymentDetails('SubscriptionCharge', event.target.value)}
                                                disabled
                                            />
                                        </div>
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>GST %</label>
                                            <input 
                                                id="txtGST" 
                                                name="txtGST" 
                                                type="number" 
                                                className="form-control"
                                                value={subscriptionPaymentDetails?.GST !== undefined ? subscriptionPaymentDetails?.GST : ''} 
                                                onChange={(event) => updateSubscriptionPaymentDetails('GST', event.target.value)}
                                            />
                                        </div>
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>GST Amount</label>
                                            <input 
                                                id="txtGSTAmount" 
                                                name="txtGSTAmount" 
                                                type="number" 
                                                className="form-control"
                                                value={subscriptionPaymentDetails?.GSTAmount !== undefined ? subscriptionPaymentDetails?.GSTAmount : ''}
                                                disabled
                                            />
                                        </div>
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>Total</label>
                                            <input 
                                                id="txtTotal" 
                                                name="txtTotal" 
                                                type="number" 
                                                className="form-control"
                                                value={subscriptionPaymentDetails?.Total !== undefined ? subscriptionPaymentDetails?.Total : ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label>Remark</label>
                                            <textarea 
                                                id="txtComment" 
                                                name="txtComment" 
                                                className="form-control" 
                                                rows="3"
                                                value={subscriptionPaymentDetails?.Comment || ''}
                                                onChange={(event) => updateSubscriptionPaymentDetails('Comment', event.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary margin-0 margin-r5"
                                data-dismiss="modal"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                            <button
                                id="btnSave"
                                onClick={addChargeHandler}
                                type="button"
                                className={`btn btn-brand margin-0 `}
                            >
                                { selectedRow?.ID ? 'Update Subscription' : 'Add Subscription'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddRangeSubscriptionModal;